/**
 * Monogram paleti (README 4.6): fotoğraf yoksa iki harf + ismin sabit karmasından
 * seçilen beş sıcak tondan biri. Gri kutu veya jenerik silüet YOK.
 */
export const monogramPalette = [
    { background: '#FBEDE3', foreground: '#8E4217' },
    { background: '#E8F1F7', foreground: '#0F4265' },
    { background: '#E4F2EC', foreground: '#0F5C44' },
    { background: '#F8F0DF', foreground: '#6E4708' },
    { background: '#EFEAF6', foreground: '#4A3670' },
];
/** Karanlık temada aynı sıra, koyu zemin/açık metin karşılığı. */
export const monogramPaletteDark = [
    { background: '#3A2415', foreground: '#F0B58A' },
    { background: '#16303F', foreground: '#9CCBE6' },
    { background: '#153228', foreground: '#8CD9BB' },
    { background: '#33280F', foreground: '#E7C77E' },
    { background: '#272040', foreground: '#BFAEE0' },
];
/**
 * İsimden sabit karma — aynı kişi her ekranda aynı rengi alır.
 * (Tasarım prototipindeki `pick()` ile birebir aynı algoritma.)
 */
export function monogramToneIndex(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) {
        hash = (hash * 31 + name.charCodeAt(i)) % 9973;
    }
    return hash % monogramPalette.length;
}
export function monogramTone(name, mode = 'light') {
    const index = monogramToneIndex(name);
    const tones = mode === 'dark' ? monogramPaletteDark : monogramPalette;
    return tones[index] ?? tones[0];
}
/** İki harf, isimden türetilir. Türkçe büyük harf dönüşümü (İ/I) zorunlu. */
export function monogramInitials(name) {
    const words = name
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0);
    if (words.length === 0)
        return '?';
    return words
        .slice(0, 2)
        .map((word) => word[0] ?? '')
        .join('')
        .toLocaleUpperCase('tr-TR');
}
//# sourceMappingURL=monogram.js.map